const tdkDict = require('./tdkDict');

function initShowNext() {
  // const rounterList = ['znm', 'zjsccydn', 'ajbc', 'dysz', 'yhhb', 'hxdx', 'yyswyq', 'wcqdn', 'zncdn', 'hjcc', 'yjc',]
  const arr = location.pathname.split('/');
  let ru = '';
  arr.forEach(item => {
    if(item.includes('.html')) {
      ru = item.split('.')[0];
    }
  })

  if (ru == 'yjc') {
    $('.next').css('display', 'none');
    $('.prev').css('display', 'block');
  } else if (ru == 'znm') {
    $('.prev').css('display', 'none');
  } else {
    $('.next').css('display', 'block');
    $('.prev').css('display', 'block');
  }
}

function initState() {
  const arr = location.pathname.split('/');
  let ru = '';
  arr.forEach(item => {
    if(item.includes('.html')) {
      ru = item.split('.')[0];
    }
  })

  $('.industry-application-tab-list-item').removeClass('line-hover');
  $('.industry-application-article-list-item').removeClass('show');
  $(`.industry-application-tab-list-item[data-id="${ru}"]`).addClass('line-hover');
  $(`.industry-application-article-list-item[data-id="${ru}"]`).addClass('show');
}

function initChange() {
  $('.industry-application-tab-list-item').on('click', function () {
    const index = $('.industry-application-tab-list-item').index(this) + 1;
    let activeId;
    activeId = $('.industry-application-tab-list-item').eq(index - 1).attr('data-id');
    const arr = location.pathname.split('/');
    location.href = location.href.replace(arr[arr.length -1], activeId + '.html')
  })
}

function prev() {
  $('.industry-application-village-article .prev').on('click', function () {
    const domList = $('.industry-application-tab-list-item');
    let index = 0;
    let activeId = null;
    domList.each((i, domEle) => {
      if(domEle.className.includes('line-hover')) {
        index = i;
      }
    })
    activeId = $('.industry-application-tab-list-item').eq(index - 1).attr('data-id');
    const arr = location.pathname.split('/');
    location.href = location.href.replace(arr[arr.length -1], activeId + '.html')
  });
}

function next() {
  $('.industry-application-village-article .next').on('click', function () {
    const domList = $('.industry-application-tab-list-item');
    let index = 0;
    let activeId = null;
    domList.each((i, domEle) => {
      if(domEle.className.includes('line-hover')) {
        index = i;
      }
    })
    activeId = $('.industry-application-tab-list-item').eq(index + 1).attr('data-id');
    const arr = location.pathname.split('/');
    location.href = location.href.replace(arr[arr.length -1], activeId + '.html')
  });
}

$(function () {
  // 初始化展示上一步下一步
  initShowNext();
  // 初始化状态
  initState();
  // 初始化tab切换
  initChange();
  // 上一篇
  prev();
  // 下一篇
  next();


  // // 初始化上一页和下一页是否显示
  // const index = Number(location.hash.split('#')[1] || 1);
  // const articleNum =
  //   document.getElementsByClassName('tab-list-item').length - 2;
  // if (index == articleNum) {
  //   $('.next').css('display', 'none');
  //   $('.prev').css('display', 'block');
  // } else if (index == 1) {
  //   $('.prev').css('display', 'none');
  // } else {
  //   $('.next').css('display', 'block');
  //   $('.prev').css('display', 'block');
  // }
  
  // // 初始化
  // const hash = location.hash.split('#')[1] || 1;
  // if (location.href.includes('application/farming')) {
  //   document.title = tdkDict[hash - 1].title;
  //   // 修改页面描述
  //   $("meta[name='description']").attr(
  //     'content',
  //     tdkDict[hash - 1].description
  //   );
  //   // 修改页面关键词
  //   $("meta[name='keywords']").attr('content', tdkDict[hash - 1].keywords);
  // }

  // $('.village-article .tab-list .tab-list-item').eq(hash - 1).addClass('line-hover');
  // $('.article-list-item').eq(hash - 1).addClass('show');

  // // tab切换
  // $('.village-article .tab-list .tab-list-item').on('click', function () {
  //   const index = $('.tab-list-item').index(this) + 1;
  //   // 去掉下面翻页的两个元素数量，上一篇和下一篇className也为tab-list-item
  //   const articleNum =
  //     document.getElementsByClassName('tab-list-item').length - 2;
  //   if (index == articleNum) {
  //     $('.next').css('display', 'none');
  //     $('.prev').css('display', 'block');
  //   } else if (index == 1) {
  //     $('.prev').css('display', 'none');
  //   } else {
  //     $('.next').css('display', 'block');
  //     $('.prev').css('display', 'block');
  //   }
  //   location.hash = index; //切换保存hash值
  //   $('.tab-list-item').removeClass('line-hover');
  //   $('.tab-list-item')
  //     .eq(index - 1)
  //     .addClass('line-hover');
  //   $('.article-list-item').removeClass('show');
  //   $('.article-list-item')
  //     .eq(index - 1)
  //     .addClass('show');
  //   if (location.href.includes('application/farming')) {
  //     document.title = tdkDict[index - 1].title;
  //     // 修改页面描述
  //     $("meta[name='description']").attr(
  //       'content',
  //       tdkDict[index - 1].description
  //     );
  //     // 修改页面关键词
  //     $("meta[name='keywords']").attr('content', tdkDict[index - 1].keywords);
  //   }
  // })

  // // 下一篇
  // $('.village-article .next').on('click', function () {
  //   // const index = $(".tab-list-item").index(this) + 1;
  //   const index = Number(location.hash.split('#')[1] || 1) + 1;
  //   const articleNum =
  //     document.getElementsByClassName('tab-list-item').length - 2;
  //   if (index == articleNum) {
  //     $('.next').css('display', 'none');
  //     $('.prev').css('display', 'block');
  //   } else {
  //     $('.next').css('display', 'block');
  //     $('.prev').css('display', 'block');
  //   }
  //   location.hash = index; //切换保存hash值
  //   $('.tab-list-item').removeClass('line-hover');
  //   $('.tab-list-item')
  //     .eq(index - 1)
  //     .addClass('line-hover');
  //   $('.article-list-item').removeClass('show');
  //   $('.article-list-item')
  //     .eq(index - 1)
  //     .addClass('show');
  //   if (location.href.includes('application/farming')) {
  //     document.title = tdkDict[index - 1].title;
  //     // 修改页面描述
  //     $("meta[name='description']").attr(
  //       'content',
  //       tdkDict[index - 1].description
  //     );
  //     // 修改页面关键词
  //     $("meta[name='keywords']").attr('content', tdkDict[index - 1].keywords);
  //   }
  // });

  // // 上一篇
  // $('.village-article .prev').on('click', function () {
  //   const index = Number(location.hash.split('#')[1] || 1) - 1;
  //   const articleNum =
  //     document.getElementsByClassName('tab-list-item').length - 2;
  //   if (index != articleNum) {
  //     $('.next').css('display', 'block');
  //   }
  //   if (index == 1) {
  //     $('.prev').css('display', 'none');
  //   } else {
  //     $('.prev').css('display', 'block');
  //   }
  //   location.hash = index; //切换保存hash值
  //   $('.tab-list-item').removeClass('line-hover');
  //   $('.tab-list-item')
  //     .eq(index - 1)
  //     .addClass('line-hover');
  //   $('.article-list-item').removeClass('show');
  //   $('.article-list-item')
  //     .eq(index - 1)
  //     .addClass('show');
  //   if (location.href.includes('application/farming')) {
  //     document.title = tdkDict[index - 1].title;
  //     // 修改页面描述
  //     $("meta[name='description']").attr(
  //       'content',
  //       tdkDict[index - 1].description
  //     );
  //     // 修改页面关键词
  //     $("meta[name='keywords']").attr('content', tdkDict[index - 1].keywords);
  //   }
  // });

  //banner图片轮播
  $(function () {
    const $imgs = $('.village-header-banner-wrap .img-swiper-item');
    if ($imgs.length > 1) {
      const $pagination = $('<div class="pagination-wrap"></div>');
      for (let i = 0; i < $imgs.length; i++) {
        $pagination.append(
          '<div class="pagination-item"><i class="white-box"></i></div>'
        );
      }
      $('.village-header-banner-wrap .img-swiper-list').after($pagination);
    }
    //
    const $paginations = $(
      '.village-header-banner-wrap .pagination-wrap .pagination-item'
    );
    //
    let activeIndex = 0;
    const activeSync = () => {
      if (!$imgs.get(activeIndex)) {
        activeIndex = 0;
      }
      $imgs.removeClass('active').eq(activeIndex).addClass('active');
      $paginations.removeClass('active').eq(activeIndex).addClass('active');
    };
    setTimeout(activeSync, 100);
    $paginations.on('click', function () {
      activeIndex = $paginations.index($(this));
      activeSync();
      restartInterval();
    });
    let interval = null;
    const restartInterval = () => {
      clearInterval(interval);
      interval = setInterval(() => {
        activeIndex++;
        activeSync();
      }, 5000);
    };
    restartInterval();
  });
});
